import React, { useState, useEffect } from 'react';
import { List, NoticeBar } from 'antd-mobile';

import * as Api from "../../../api/usms";
import { formatBillUnit, getSthousandsFormatNum } from '../utils/common';
import { Loading } from '../components';

const Item = List.Item;
const Brief = Item.Brief;

/* 表格附加信息，单独调用运营平台API查询，明细信息在运营侧 */
function ChannelList(props) {
  const { statisticsTime } = props;

  const [mainList, setMainList] = useState([]);
  const [preList, setPreList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (props.info) {
      getList({
        ...statisticsTime,
        Id: props.info.Id,
      });
    }
    // eslint-disable-next-line
  }, [props.info.Id]);

  const getList = data => {
    setLoading(true);
    Api.GetDispatchConfigDetail(data).then(res => {
      // 其实info里已经有了通道信息了，这里是重新拿一下各个通道的详细信息用于列表展示
      const dataList = res.Data ? (res.Data.List || []) : [];
      setMainList(dataList.filter(item => item.Type === 0));
      setPreList(dataList.filter(item => item.Type === 1));
      setLoading(false);
    });
  };

  return <Loading loading={loading}>
    {mainList.length ?
      <List renderHeader={() => '主通道'}>
        {mainList.map((channel, index) => {
          return <Item
            key={index}
            arrow={null}
            multipleLine
            onClick={() => { }}
            platform="cross"
          >
            {channel.ChannelId}<Brief>{`权重：${channel.Weight} ，成本：${formatBillUnit(channel.Price)}，售价：${formatBillUnit(channel.AccountPrice)}`}
              <br />
              {`发送量：${getSthousandsFormatNum(channel.TotalCount)} ， 成功率：${channel.TotalCount
                ? ((channel.SuccessCount / channel.TotalCount) * 100).toFixed(3) + '%'
                : '0.000%'}`}</Brief>
          </Item>

        })}
      </List> : null}

    {preList.length ? <List renderHeader={() => '备通道'}>
      {preList.map((channel, index) => {
        return <Item
          key={index}
          arrow={null}
          multipleLine
          onClick={() => { }}
          platform="cross"
        >
          {channel.ChannelId}<Brief>{`权重：${channel.Weight} ，成本：${formatBillUnit(channel.Price)}，售价：${formatBillUnit(channel.AccountPrice)}`}
            <br />
            {`发送量：${getSthousandsFormatNum(channel.TotalCount)} ， 成功率：${channel.TotalCount
              ? ((channel.SuccessCount / channel.TotalCount) * 100).toFixed(3) + '%'
              : '0.000%'}`}</Brief>
        </Item>

      })}
    </List> : null}

    {preList.length <= 0 && mainList.length <= 0 ? <NoticeBar style={{ marginTop: '20px' }} icon={null}>
        {`暂未查询到主备通道信息。`}
    </NoticeBar> : null }
  </Loading>
}

export default ChannelList;
